import { type FC, memo, type ReactNode, useCallback, useMemo, useState } from "react";
import debounce from "lodash/debounce";
import { QuantityInput } from "../../../../common/components/QuantityInput/QuantityInput";

interface CartQuantityInputProps {
  className?: string;
  hidden?: boolean;
  value: number | undefined;
  label: ReactNode;
  helperLabel?: string;
  error?: boolean;
  disabled?: boolean;
  allowedLength?: number;
  onFocus?: () => void;
  onBlur?: () => void;
  hideButtons?: boolean;

  onChange: (newValue: number) => void;
  "data-test-id"?: string;
  step?: number;
}

const CartQuantityInput: FC<CartQuantityInputProps> = (props) => {
  const { value, onChange, onBlur: onBlurCb, step = 1, ...otherProps } = props;

  const [outerValue, setOuterValue] = useState(value);
  const [innerValue, setInnerValue] = useState(value);

  const debouncedHandleState = useMemo(() => {
    return debounce(onChange, 500);
  }, [onChange]);

  const cb = useCallback(
    (newValue: number) => {
      setInnerValue(newValue);
      debouncedHandleState(newValue);
    },
    [debouncedHandleState],
  );

  const onBlur = useCallback(() => {
    onBlurCb?.();
    setInnerValue(outerValue);
  }, [outerValue]);

  if (outerValue !== value) {
    setInnerValue(value);
    setOuterValue(value);
  }

  return <QuantityInput {...otherProps} onValueChange={cb} value={innerValue} onBlur={onBlur} step={step} min={step} />;
};

export default memo(CartQuantityInput);
